<template>
  <div class="container">
    <p style="color: #52718e;font-size: 17px;margin: 36px 0 0px 10px;">相关展会信息
      <span>(共<span style="color:red;">{{detail.expocount}}</span>条)</span>
    </p>
    <a-table v-show="!loading&&detail.expocount!=0" class="exh-list" :dataSource="dataSource" :pagination="pagination" rowKey="index" @change="handleTableChange">
      <a-table-column title="序号" dataIndex="index" :width="60" align="center"> </a-table-column>
      <a-table-column title="展会名称" dataIndex="name"> </a-table-column>
      <a-table-column title="展会行业" dataIndex="industry" :width="400" align="center"> </a-table-column>
      <a-table-column title="所属区域" dataIndex="country" :width="200" align="center"> </a-table-column>
    </a-table>
    <div v-show="loading&&detail.expocount!=0" style="text-align:center;margin:150px;">
          <a-spin tip="加载中...">
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 48px;width:48px;height:48px;"
              spin
            />
          </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading:false,
      pageNo: 1,
      totalCount: 0,
      pageSize: 10,
      dataSource: [],
      pagination: { defaultPageSize: 10 }
    };
  },
  props: {
    detail: { type: Object, required: true }
  },
  methods: {
    handleTableChange(p) {
      this.pageNo = p.current;
      this.loadPurchaserExpositionList();
    },
    loadPurchaserExpositionList() {
      this.loading=true;
      this.$http
        .post("zzAttendExpositionList", {
          pid: this.detail.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        .then(res => {
          if (!res.error) {
            console.log(res)
            this.totalCount = parseInt(res.totalCount);

            this.pagination = { ...this.pagination, total: this.totalCount };

            this.pageNo = parseInt(res.pageNo);
            this.pageSize = parseInt(res.pageSize);
            this.dataSource = res.data.list.map((d, i) => {
              d.index = (this.pageNo - 1) * this.pageSize + i + 1;
              return d;
            });
          }
          this.loading=false;
        }).catch(e => {
          this.loading = false;
        });
    }
  },
  created() {
    this.loadPurchaserExpositionList();
  }
};
</script>
<style lang="scss" >
.container{
    min-height: 500px;
}
.ant-tooltip-content {
  .ant-tooltip-arrow {
    border-bottom-color: #c9c9c9;
  }
  .ant-tooltip-inner {
    background-color: #c9c9c9;
    color: #fff;
    p {
      margin: 10px;
    }
  }
}
.exh-list {
  margin-bottom: 40px;

  .ant-table-body {
    .ant-table-tbody {
      tr {
        &:nth-child(even) {
          background: #f3fbff;
        }
        td {
          border: none !important;
        }
      }
    }
    .ant-table-thead {
      tr {
        box-shadow: 0px -5px 20px #fafafa inset;
        border-bottom: 1px solid #f2f2f2;
        th {
          padding: 9px 5px 9px 10px;
          background: none;
          font-weight: bold;
          // text-align: center;
          i {
            font-size: 13px;
            color: #c9c9c9;
            font-weight: normal;
          }
        }
      }
    }
  }
  .ant-table-pagination.ant-pagination{
    float:none;
  }
}
</style>
